(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
(function (global){
//Sliding Compare Panel

(function() {
  
	var widgetId = "#currency-converter-widget",
		$converterWidget = $(widgetId),
		$inputFields = $converterWidget.find('input[name=to], input[name=from]'),
		$inputTo = $converterWidget.find('input[name=to]'),
		$inputFrom = $converterWidget.find('input[name=from]'),
		$conversionBlock = $(".js-conversion"),
		$conversionError = $(".js-conversion-error"),
		$compareText = $('.js-compare-text'),
		//$savingsAmount = $('.js-savings-amount'),
    $interBankRate = $('.js-interbankrate'),
		$currencySelectInputs = $(widgetId + ' select[name=cur-from], ' + widgetId + ' select[name=cur-to]'),
		$currencySelectFrom = $(widgetId + ' select[name=cur-from]'),
		$currencySelectTo = $(widgetId + ' select[name=cur-to]'),
		$allInputs = $inputFields.add( $currencySelectInputs),
		$compareButton = $(widgetId + ' .js-compare-btn'),
		//converterApiUrl = "http://www.currenciesdirect.com/CurrencyRate/Convert",
    converterApiUrl = "/en/CurrenciesDirectRateApi/CurrencyConverter",
		enableCookiesStorage = !$converterWidget.hasClass('widget-converter__feature_nocookies');

	var $quoteForm = $('#quoteAddOn'),
		quoteFormExists = $quoteForm.length > 0,
		$quoteCurrencyAmountInput = $quoteForm.find('input[name=Amount]'),
		$quoteCurrencyFrom = $quoteForm.find('input[name=CurrencyFrom]'),
		$quoteCurrencyTo = $quoteForm.find('input[name=CurrencyTo]');

	function updateValues(data, currentInputElement, reverted) {

		var $inputElement = $(currentInputElement);
		var inputValue = $inputElement.val();

		if(quoteFormExists) {
			$quoteCurrencyAmountInput.val($inputFrom.val());
      $('#quoteSummary-Amt').html($inputFrom.val());
			$quoteCurrencyFrom.val($currencySelectFrom.val());
      $('#quoteSummary-From').removeClass().addClass('flag').addClass($currencySelectFrom.val().toLowerCase());
      $('#quoteSummary-From').html($currencySelectFrom.val());
			$quoteCurrencyTo.val($currencySelectTo.val());
      $('#quoteSummary-To').removeClass().addClass('flag').addClass($quoteCurrencyTo.val().toLowerCase());
      $('#quoteSummary-To').html($quoteCurrencyTo.val());
		}

		if (inputValue == "") {
			// console.log("We can't do nothing if you don't give us some figures");
			return;
		} else {
			$inputElement.val(inputValue.replace(/[^0-9,.]/g, ""));
		}

		var output,
			savings = parseFloat(data.Savings);
      
    var interRate = parseFloat(data.Rate);

		var savedAmount = savings + " " + $currencySelectFrom.find('option:selected').val();

		if(data.Status == "Success") {

			$conversionError.addClass('hidden');
			$conversionBlock.removeClass('hidden');

			output = data.ToAmount.toFixed(2);
			//$savingsAmount.html(savedAmount);
      $interBankRate.html(interRate);

		} else {
      
			$conversionBlock.addClass('hidden');
			$conversionError.removeClass('hidden');
			$compareButton.addClass('hidden');
			output = 0;
      
		}

		if(reverted) {
			$inputFrom.val(output);
		} else {
			$inputTo.val(output);
		}

		// update path
		var pageUrl = window.location.pathname 
				+ "?curIn=" + $inputFrom.val() 
				+ "&curOut=" + $inputTo.val() 
				+ "&curTo=" + $currencySelectTo.val()
				+ "&curFrom=" + $currencySelectFrom.val();

		if (quoteFormExists && enableCookiesStorage) {
			global.cdweb.updateURL( pageUrl );
		}
	}

	function inputValuesChangeHandler(e) {

		var ele = this;

		var inputValue = $(ele).val(),
			fromVal = $currencySelectFrom.val(),
			toVal = $currencySelectTo.val(),
			valuesReverted = ele.getAttribute('name') == 'to';

		if(enableCookiesStorage) {
			// update cookie value
			$.cookie('BL-AMOUNT', $inputFrom.val(), { expires: 14, path: '/', domain: '.' + location.host.replace("www.", "").replace("dev.", "").replace("staging.", "") });
			$.cookie('BL-CURRENCY', fromVal + toVal, { expires: 14, path: '/', domain: '.' + location.host.replace("www.", "").replace("dev.", "").replace("staging.", "") });
		}

		if(valuesReverted) {
			var t;
			t = fromVal;
			fromVal = toVal;
			toVal = t;
		}

    //console.log("from:" + fromVal + ", to:" + toVal + ", amount:" + inputValue + ", isReverted:" + valuesReverted);

		var $ajax = $.get(
			converterApiUrl,
			{
				"from": fromVal,
				"to": toVal,
				"amount": inputValue,
				"isReverted": valuesReverted
			},
      function(data) {
        var newData =JSON.stringify(data).replace(/\[/g,'').replace(/\]/g,'');
        var MyData = JSON.parse(newData);
				//console.log(JSON.stringify(MyData));
				if( !MyData ) return;
				updateValues(MyData, ele, valuesReverted);
			},
			"json"
		);
	}

	function checkSimilarCurrenciesDisabled() {
    
		var currentValueFrom = $currencySelectFrom.val(),
			currentValueTo = $currencySelectTo.val();

		$currencySelectInputs
			.find('option:disabled')
			.removeAttr('disabled');

		$currencySelectTo
			.find('option[value="'+ currentValueFrom +'"], option[value="separator"]')
			.attr('disabled', 'disabled');

		$currencySelectFrom
			.find('option[value="'+ currentValueTo +'"], option[value="separator"]')
			.attr('disabled', 'disabled');
	}

	$inputFields.on('keyup', _.debounce(inputValuesChangeHandler, 300));
	$inputFields.on('change', inputValuesChangeHandler);
  $currencySelectInputs.on('change', inputValuesChangeHandler);

	$inputFields.on("keypress", function(e) {

		if ((e.which != 46 || $(this).val().indexOf('.') != -1) && (e.which < 48 || e.which > 57) && (e.which != 0 && e.which != 8)) {
			e.preventDefault();
		}
	});


	$currencySelectInputs.on('change', function() {
		$inputFrom.trigger('keyup');
		checkSimilarCurrenciesDisabled();
	});

	function initializeFromCookies() {
    
    //console.log('initializeFromCookies');
    
		var inputValue = $.cookie('BL-AMOUNT'),
			inputCurrencies = $.cookie('BL-CURRENCY');

		if (inputValue && inputCurrencies && inputCurrencies.length == 6) {
			$inputFrom.val(inputValue);
			$currencySelectFrom.val(inputCurrencies.substring(0,3)).trigger('change');
			$currencySelectTo.val(inputCurrencies.substring(3,6)).trigger('change');
		}
	}

	if(enableCookiesStorage) {
		initializeFromCookies();
	}

	$inputFrom.trigger('change');
	checkSimilarCurrenciesDisabled();

	//If using full tool not widget some extra options for URL changes and additional functionality.
	if (quoteFormExists) {

		$(widgetId + ' select').on('change', function (e) {
			global.cdweb.updateURL( window.location.pathname );
		});

		$(widgetId + ' input').on('keyup', function (e) {
			global.cdweb.updateURL( window.location.pathname );
		});

		$('#quoteAddOn .confirmationScreen .button').on('click', function (e) {
			e.preventDefault();
			$(widgetId).removeClass('active');
			$('#quoteAddOn .confirmationScreen, #quoteAddOn').hide();
		});

	} else {

		$(widgetId + ' #getQuote').on('click', function (e) {

			$(widgetId + ' form').submit();

		});
	};
})();
}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],2:[function(require,module,exports){
var currencyConverterWidget = require('./components/currencyConverterWidget');
},{"./components/currencyConverterWidget":1}]},{},[2]);
